<template>
  <div class="chat-msg-item">
    <div
      v-if="item.messageType === 25"
      class="into-room"
    >
      欢迎{{ item.content }}进入直播间
    </div>
    <div
      v-else
      class="msg"
    >
      <div class="el-avatar-item">
        <el-avatar
          icon="el-icon-user-solid"
          :size="30"
          :src="item.senderUserIcon"
        />
        <span class="name">{{ item.senderUserName }}</span>
      </div>

      <div
        v-if="item.messageType === 20"
        class="text-item"
      >
        <i class="el-icon-caret-left" />
        <span class="text">
          {{ item.content }}
        </span>
      </div>
      <el-image
        v-if="item.messageType === 30"
        style="width: 100px; height: 100px"
        :src="item.content"
        fit="contain"
        :preview-src-list="[item.content]"
      />
    </div>
  </div>
</template>
<script>

export default {
  name: 'FomTitle',
  props: {
    item: {
      type: [Object],
      default: () => ({ senderUserIcon: '' }),
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.chat-msg-item{
  margin-bottom: 15px;
  .into-room{
    color: $--base-color-main;
    font-size: 16px;
    padding: 5px 20px;
  }
  .msg{
    display: inline-flex;
    align-items: center;
    // padding: 4px 16px 4px 4px;
    border-radius:20px;
    margin-left: 15px;
    // background: rgba($--base-color-main, 0.9);
    .el-avatar-item{
      min-width: 32px;
      margin-right: 12px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      span.name{
        color: $--base-color-main;
        font-size: 12px
      }
    }
  }
  .text-item{
    // margin-left: 12px;
    color:#ffffff;
    background: #DBDBDB;
    border-radius: 8px;
    padding: 8px 12px;
    font-size: 14px;
    min-width: 240px;
    margin-right: 40px;
    word-wrap:break-word;
    margin-top: -12px;
    position: relative;
    .el-icon-caret-left{
      position: absolute;
      top: 0;
      bottom: 0;
      left: -9px;
      margin: auto;
      display: inline-flex;
      align-items: center;
      color: #DBDBDB !important;
    }
    .text{
        word-wrap: break-word;
        word-break: break-word;
    }
  }
}
</style>
